var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthLayout',[_c('a',{attrs:{"href":_vm.route('auth.login')}},[_vm._v("Login")]),_vm._v(" "),_c('h2',[_vm._v("Place for team invitation")]),_vm._v(" "),_c('pre',{domProps:{"innerHTML":_vm._s(JSON.stringify(_vm.invitation, null, 4))}})])}
var staticRenderFns = []

export { render, staticRenderFns }